export const DRAWER_WIDTH = 280;

export const DAYS_FOR_COMPLETE_REVIEW = 20;

export const MAX_NUMBER_OF_BOOKMARK_PROJECTS = 6;

export const ENABLE_ANNOTATION = true;
export const SHOW_ANNOTATION_BETA = true;

export const WORKFLOW_LINK_DUE_DATE = new Date('2024-02-29T23:59:59');
export const SHOW_LINK_DUE_DATE = new Date() < WORKFLOW_LINK_DUE_DATE;

export const ACTIVE_ACCOUNT_KEY = 'backspace-active-account'; // localStorage key for active account
